import React from "react";
import PDF417 from "pdf417-generator";

const Barcode417 = ({str = 'something'})=>{

    React.useEffect(()=>{
        const canvas  = document.getElementById("PDF417");
        PDF417.draw(str, canvas,1);
    },[]);

    return (
      <div className='form-group'>
        <canvas id="PDF417" className ='pull-right mr-5'  width = '180' height = '80' />
        <span className='d-block ml-2'>ID:{str.substring(0,30)}</span>
      </div>
    )
};

export default Barcode417;